/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

// Services
import { BeneficiaryService } from "@/services/beneficiary.service";

// Types
import { Beneficiary } from "@/types/beneficiary";

/* -------------------------------------------------------------------------- */
/*                              Beneficiary Hook                              */
/* -------------------------------------------------------------------------- */
const beneficiaryService = new BeneficiaryService();

type UseBeneficiaryQueryArgs = {
  id: string;
};

const beneficiaryQueryOptions = (id: string): UseQueryOptions<Beneficiary> => ({
  queryKey: ["beneficiary", id],
  queryFn: () => beneficiaryService.getOne({ id }),
  enabled: !!id,
});

const useBeneficiary = ({ id }: UseBeneficiaryQueryArgs) => {
  const queryOptions = beneficiaryQueryOptions(id);
  const { data, isLoading } = useQuery(queryOptions);

  return {
    data,
    isLoading,
  };
};

export { useBeneficiary, beneficiaryQueryOptions };
